import { defineNuxtRouteMiddleware } from 'nuxt/app';
import { useGlobalStore } from '../stores/global/global-store'

export default defineNuxtRouteMiddleware((to, from) => {
    const GlobalStore = useGlobalStore()
    GlobalStore.push_user_track(from.fullPath) 
})